import { render, staticRenderFns } from "./UICheckbox.vue?vue&type=template&id=6524dfd8&scoped=true&"
import script from "./UICheckbox.vue?vue&type=script&lang=js&"
export * from "./UICheckbox.vue?vue&type=script&lang=js&"
import style0 from "./UICheckbox.vue?vue&type=style&index=0&id=6524dfd8&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6524dfd8",
  null
  
)

export default component.exports